module.exports = __webpack_public_path__ + "img/site-dashboard.47778461.svg";